import React from 'react';
import classNames from 'classnames';
import { Box } from '@stockx/ui';

import { NavBarWrapper, NavBarButtonStyles } from './ContentWrapper.styles';

import useContentWrapper from './hooks/useContentWrapper';

const ContentWrapper = ({ children }) => {
  const { classes } = useContentWrapper();

  return (
    <NavBarWrapper
      data-component="NavBarWrapper"
      className={classNames(classes)}
      backgroundColor="#ffffff"
      borderBottom="1px solid"
      borderBottomColor="#cfcfcf"
    >
      <Box
        id="header-wrapper"
        data-component="NavBarColorSwap"
        sx={{
          '.nav-main-wrapper > li > a': {
            color: 'neutral.700',
            '&.clear-ask': {
              borderColor: 'neutral.700',
            },
            '&:hover': {
              color: 'neutral.700',
            },
          },
        }}
      >
        <Box sx={NavBarButtonStyles}>{children}</Box>
      </Box>
    </NavBarWrapper>
  );
};

export default ContentWrapper;
